const initialState = { name: "", address: "", gst: "" };

export function platformCompany(state = initialState, action) {
  switch (action.type) {
    case "PLATFORM_COMPANY_FETCH_SUCCESS":
      return action.data;
    default:
      return state;
  }
}
